
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 54","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#0071FF","fill-rule":"nonzero","d":"M45.61.69l9.01 9.01H70L63.81.69z"}}),_c('path',{attrs:{"fill":"#3E98FF","fill-rule":"nonzero","d":"M6.19 53.31V.69h56.44v52.62z"}}),_c('path',{attrs:{"fill":"#0071FF","fill-rule":"nonzero","d":"M6.19.69h18.2v52.62H6.19z"}}),_c('path',{attrs:{"fill":"#3E3E3D","fill-rule":"nonzero","d":"M24.39 8.29V4.38h34.99v3.91z"}}),_c('path',{attrs:{"fill":"#222221","fill-rule":"nonzero","d":"M9.45 8.3V4.39h14.94V8.3z"}}),_c('path',{attrs:{"fill":"#3E3E3D","fill-rule":"nonzero","d":"M24.39 49.87v-3.91h34.99v3.91z"}}),_c('path',{attrs:{"fill":"#222221","fill-rule":"nonzero","d":"M9.45 49.88v-3.91h14.94v3.91z"}}),_c('path',{attrs:{"stroke":"#3E98FF","stroke-width":".43","fill":"#3E3E3D","d":"M40.07 37.27l3.47-5.9-3.47-1.97zM48.15 24.47l-7.78 4.41.04.02 7.74 4.38 7.78-4.4z"}}),_c('path',{attrs:{"stroke":"#3E98FF","stroke-width":".43","fill":"#3E3E3D","d":"M48.15 33.98l-4.08-2.32-3.89 6.61 7.86 4.45L55.7 29.7zM48.98 42.32l6.95-3.94-3.48-1.97zM40.07 37.27l3.47-5.9-3.47-1.97z"}}),_c('path',{attrs:{"stroke":"#3E98FF","stroke-width":".43","fill":"#3E3E3D","d":"M48.15 24.47l-7.78 4.41.04.02 7.74 4.38 7.78-4.4z"}}),_c('path',{attrs:{"stroke":"#3E98FF","stroke-width":".43","fill":"#3E3E3D","d":"M48.15 33.98l-4.08-2.32-3.89 6.61 7.86 4.45L55.7 29.7zM48.98 42.32l6.95-3.94-3.48-1.97z"}}),_c('path',{attrs:{"fill":"#3E98FF","fill-rule":"nonzero","d":"M24.39.69L17.26 9.7H0L6.19.69z"}})])])
          )
        }
      }
    